import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/referrals/`;

export const referral = {
  get: () => generateApiPath(pathBase),
};
